module.exports = __webpack_public_path__ + "media/bootstrap-icons/briefcase-63a1200a.svg";